module.exports = __webpack_public_path__ + "img/24_b_storm.f9987c59.jpg";